import * as React from 'react';

import { Input } from './Input';

/**
 * Renders a positive number input.
 */
export class PositiveNumberInput extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return <Input {...this.props} type="number" min={0} />;
    }
}
